import React from "react";
import ReactDOM from "react-dom";

import Authentication from "../src/features/authentication/src";

const authenticationElement = document.getElementById("authentication");
const { showGoogle, siteKey } = authenticationElement.dataset;

ReactDOM.render(
  <Authentication showGoogle={showGoogle === "true"} siteKey={siteKey} />,
  authenticationElement
);
